import { Button, type ButtonProps } from "react-bootstrap";
import { MdCheck } from "react-icons/md";

const OkButton: TTButtonProps = ({ children, ...props }) => (
  <Button {...(props as ButtonProps)}>
    <MdCheck /> {children}
  </Button>
);

export default OkButton;
